module.exports = __webpack_public_path__ + "static/media/samsung-aife-2019-performance.98db377f.mp4";